// extracted by mini-css-extract-plugin
export default {"logo":"LogoLink2_logo__iGoD-"};